/* eslint-disable */
export default {
  removeParticipant: 'Remove Participant',
  confirmStr1: 'Are you sure you want to remove',
  confirmStr2: 'from this call?',
  remove: 'Remove',
  cancel: 'Cancel',
  participants: 'Participants',
  participant: 'Participant',
  conferenceCall: 'Conference Call',
  unknownNumber: 'Anonymous',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
